import { render, staticRenderFns } from "./MessageText.vue?vue&type=template&id=2acf8eb5&scoped=true&"
import script from "./MessageText.vue?vue&type=script&lang=ts&"
export * from "./MessageText.vue?vue&type=script&lang=ts&"
import style0 from "./MessageText.vue?vue&type=style&index=0&id=2acf8eb5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2acf8eb5",
  null
  
)

export default component.exports